import { useAtom, atom } from 'jotai';

const dismissedSubmissionIdsAtom = atom<string[]>([]);

// Session-scoped memory of the pending-questionnaire modals the user closed.
// Global (atom) because `PendingScheduleQuestionnaireModal` does not survive
// an organization-switcher refetch — searching briefly blanks the pending
// list, which unmounts the modal; on remount it must not resurrect a
// submission the user already dismissed.
export const useDismissedQuestionnairesStore = () => {
  const [dismissedSubmissionIds, setDismissedSubmissionIds] = useAtom(
    dismissedSubmissionIdsAtom,
  );

  return { dismissedSubmissionIds, setDismissedSubmissionIds };
};
